var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main-container",
      style: { "--logo-col-width": _vm.logoColWidth },
    },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _vm.selectedMemberIds.length
            ? _c(
                "button",
                {
                  staticClass: "header-button selection-action-button",
                  attrs: { type: "button" },
                  on: { click: _vm.handleSelectionAction },
                },
                [_vm._v("\n            Update Unavailable Days\n        ")]
              )
            : _vm._e(),
          _c(
            "md-checkbox",
            {
              staticClass: "header-button checkbox",
              attrs: { disabled: _vm.disableFilters, type: "checkbox" },
              on: { change: _vm.handleWeekChange },
              model: {
                value: _vm.showUnavailableOnly,
                callback: function ($$v) {
                  _vm.showUnavailableOnly = $$v
                },
                expression: "showUnavailableOnly",
              },
            },
            [_vm._v("\n            Show Unavailable Only\n        ")]
          ),
          _c("div", { staticClass: "rows-per-page-container" }, [
            _c("label", { attrs: { for: "rowsPerPage" } }, [
              _vm._v("Rows per page:"),
            ]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedRowsPerPage,
                    expression: "selectedRowsPerPage",
                  },
                ],
                staticClass: "rows-per-page-select",
                attrs: { id: "rowsPerPage", disabled: _vm.disableFilters },
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedRowsPerPage = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.handleRowsPerPageChange,
                  ],
                },
              },
              [
                _c(
                  "option",
                  { domProps: { value: _vm.DEFAULT_ROWS_PER_PAGE } },
                  [_vm._v(_vm._s(_vm.DEFAULT_ROWS_PER_PAGE))]
                ),
                _c("option", { domProps: { value: null } }, [_vm._v("All")]),
              ]
            ),
          ]),
          _c(
            "md-datepicker",
            {
              ref: "mdDatePicker",
              attrs: { "md-immediately": "", "md-debounce": 10 },
              model: {
                value: _vm.dateFilter,
                callback: function ($$v) {
                  _vm.dateFilter = $$v
                },
                expression: "dateFilter",
              },
            },
            [_c("label", [_vm._v("Date Range")])]
          ),
          _c(
            "button",
            {
              staticClass: "header-button week-nav-button",
              attrs: { disabled: _vm.disableFilters, type: "button" },
              on: {
                click: function ($event) {
                  return _vm.previousWeek()
                },
              },
            },
            [
              _c("md-icon", { staticClass: "icon-chevron-right" }, [
                _vm._v("chevron_left"),
              ]),
              _c("span", { staticClass: "left-button-text" }, [
                _vm._v("Previous"),
              ]),
            ],
            1
          ),
          _c(
            "button",
            {
              staticClass: "header-button week-nav-button",
              attrs: { disabled: _vm.disableFilters, type: "button" },
              on: {
                click: function ($event) {
                  return _vm.nextWeek()
                },
              },
            },
            [
              _c("span", { staticClass: "right-button-text" }, [
                _vm._v("Next"),
              ]),
              _c("md-icon", { staticClass: "icon-chevron-right" }, [
                _vm._v("chevron_right"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.isListLoading
        ? _c(
            "div",
            [
              _c("div", { staticClass: "roster-table-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "roster-table-container",
                    on: {
                      mouseleave: function ($event) {
                        return _vm.resetHoveredRow()
                      },
                    },
                  },
                  [
                    _c("table", { staticClass: "roster-table" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _c("th", { staticClass: "col-select" }, [
                              _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  "aria-label": "Select all team members",
                                },
                                domProps: {
                                  checked: _vm.isAllSelected,
                                  indeterminate: _vm.isIndeterminate,
                                },
                                on: { change: _vm.toggleSelectAll },
                              }),
                            ]),
                            _c("th", { staticClass: "col-photo" }),
                            _c("th", { staticClass: "col-name" }, [
                              _vm._v("Team Member"),
                            ]),
                            _vm._l(_vm.dateColumns, function (col, colIndex) {
                              return _c(
                                "th",
                                {
                                  key: "header-" + colIndex,
                                  staticClass: "col-date",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(col.columnName) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.memberList, function (item, index) {
                          return _c(
                            "tr",
                            {
                              key: index,
                              class: {
                                "hovered-row": _vm.hoveredRowIndex === index,
                              },
                              on: {
                                mouseenter: function ($event) {
                                  return _vm.handleRowHover(index)
                                },
                              },
                            },
                            [
                              _c("td", { staticClass: "col-select" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedMemberIds,
                                      expression: "selectedMemberIds",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    "aria-label": "Select team member",
                                  },
                                  domProps: {
                                    value: item.publicUserId,
                                    checked: Array.isArray(
                                      _vm.selectedMemberIds
                                    )
                                      ? _vm._i(
                                          _vm.selectedMemberIds,
                                          item.publicUserId
                                        ) > -1
                                      : _vm.selectedMemberIds,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    change: function ($event) {
                                      var $$a = _vm.selectedMemberIds,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = item.publicUserId,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectedMemberIds = $$a.concat(
                                              [$$v]
                                            ))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectedMemberIds = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectedMemberIds = $$c
                                      }
                                    },
                                  },
                                }),
                              ]),
                              _c(
                                "td",
                                { staticClass: "col-photo" },
                                [
                                  _vm.loggedInUserEmail != item.email
                                    ? _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "Team Member Profile",
                                              params: {
                                                publicUserId: item.publicUserId,
                                              },
                                            },
                                          },
                                        },
                                        [
                                          item.photoUrl
                                            ? _c("img", {
                                                staticClass:
                                                  "circle-profile-image",
                                                attrs: {
                                                  src: item.photoUrl,
                                                  alt: "",
                                                },
                                                on: {
                                                  error:
                                                    _vm.$_setDefaultBrokenImage,
                                                },
                                              })
                                            : _c("img", {
                                                staticClass:
                                                  "circle-profile-image",
                                                attrs: {
                                                  src: _vm.$root
                                                    .defaultPhotoUrl,
                                                  alt: "",
                                                },
                                              }),
                                        ]
                                      )
                                    : _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "User Profile" },
                                          },
                                        },
                                        [
                                          item.photoUrl
                                            ? _c("img", {
                                                staticClass:
                                                  "circle-profile-image",
                                                attrs: {
                                                  src: item.photoUrl,
                                                  alt: "",
                                                },
                                                on: {
                                                  error:
                                                    _vm.$_setDefaultBrokenImage,
                                                },
                                              })
                                            : _c("img", {
                                                staticClass:
                                                  "circle-profile-image",
                                                attrs: {
                                                  src: _vm.$root
                                                    .defaultPhotoUrl,
                                                  alt: "",
                                                },
                                              }),
                                        ]
                                      ),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticClass: "col-name" },
                                [
                                  _vm.loggedInUserEmail != item.email
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass: "custom-a-blue",
                                          attrs: {
                                            to: {
                                              name: "Team Member Profile",
                                              params: {
                                                publicUserId: item.publicUserId,
                                              },
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.fullName) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "router-link",
                                        {
                                          staticClass: "custom-a-blue",
                                          attrs: {
                                            to: { name: "User Profile" },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.fullName) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                              _vm._l(
                                _vm.dateColumns,
                                function (col, dateColIndex) {
                                  return _c(
                                    "td",
                                    {
                                      key: "cell-" + index + "-" + dateColIndex,
                                      staticClass: "col-date",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "indicator-container" },
                                        [
                                          _c("availability-indicator", {
                                            staticClass: "indicators",
                                            attrs: {
                                              "is-available": _vm.isAvailable(
                                                item,
                                                col
                                              ),
                                            },
                                          }),
                                          _vm.unavailabilityReason(item, col)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "info-container",
                                                },
                                                [
                                                  _c("md-icon", [
                                                    _vm._v("info"),
                                                  ]),
                                                  _c(
                                                    "md-tooltip",
                                                    {
                                                      attrs: {
                                                        "md-direction": "top",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.unavailabilityReason(
                                                              item,
                                                              col
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm.memberList.length == 0 && !_vm.isLoading
                ? _c("div", [
                    _c("p", { staticClass: "no-result-message" }, [
                      _vm._v(
                        "No results matching your search/filter could be found."
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "md-card-actions",
                {
                  staticClass: "page-footer",
                  attrs: { "md-alignment": "space-between" },
                },
                [
                  _c("div", [
                    _vm.total === _vm.pagination.perPage
                      ? _c("p", { staticClass: "card-category" }, [
                          _vm._v(
                            "\n                    Page " +
                              _vm._s(_vm.pagination.currentPage) +
                              " of many\n                "
                          ),
                        ])
                      : _c("p", { staticClass: "card-category" }, [
                          _vm._v(
                            "Page " +
                              _vm._s(_vm.pagination.currentPage) +
                              " of " +
                              _vm._s(_vm.totalPages)
                          ),
                        ]),
                  ]),
                  _c("pagination", {
                    staticClass: "pagination-no-border pagination-success",
                    attrs: {
                      "per-page": _vm.pagination.perPage,
                      total: _vm.total,
                    },
                    on: {
                      "change-page": function ($event) {
                        return _vm.handleChangePage(
                          $event,
                          _vm.pagination.perPage
                        )
                      },
                    },
                    model: {
                      value: _vm.pagination.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.pagination, "currentPage", $$v)
                      },
                      expression: "pagination.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c("div", [
            _c("div", { staticClass: "body-list" }, [
              _c(
                "div",
                { staticClass: "list-loader" },
                [
                  _c("fade-loader", {
                    attrs: { loading: _vm.isListLoading, color: "#333333" },
                  }),
                  _c("span", [_vm._v("LOADING")]),
                ],
                1
              ),
            ]),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }